export default __webpack_public_path__ + "static/media/LOGO.ecdc61e7.webp";